import React, { useState } from 'react';
import ban100 from '../../../assets/ban100.png';
import davivienda from '../../../assets/daviviendaUniversal2.png';
import ThreeDButton from '../../3dButton';

const productos = [
  {
    id: 1,
    duracion: '6 meses',
    monto: '$10.000.000',
    proveedor: 'BAN100',
    logo: ban100,
    cerrado: true,
  },
  {
    id: 2,
    duracion: '12 meses',
    monto: '$5.000.000',
    proveedor: 'DAVIVIENDA',
    logo: davivienda,
    cerrado: false,
  },
];

const Movimientos = () => {
  const [selected, setSelected] = useState('General');

  const selectedItem = productos.find(p => p.id === selected);

  return (
    <div className="flex gap-4 text-sm">
      <div className="w-1/4 rounded-md py-4 pl-4 pr-4 space-y-4 bg-[#ddedf0] flex flex-col">
        <ThreeDButton
          text="General"
          selected={selected === 'General'}
          onClick={() => setSelected('General')}
        />
        {productos.map((p) => (
          <ThreeDButton
            key={p.id}
            text={`${p.proveedor} - ${p.duracion} - ${p.monto}`}
            selected={selected === p.id}
            onClick={() => setSelected(p.id)}
          />
        ))}
      </div>

      <div className="w-3/4 bg-[#edf5fe] rounded-md p-6 text-blue-900">
        <div className="text-xl font-semibold mb-4">Movimientos</div>

        {selected === 'General' ? (
          <table className="w-full text-left">
            <thead className="border-b border-blue-300">
              <tr>
                <th className="pb-2">Fecha</th>
                <th className="pb-2">Tipo</th>
                <th className="pb-2">Descripción</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-blue-200">
              {productos.map((p) => (
                <React.Fragment key={p.id}>
                  <tr>
                    <td>01/01/2024</td>
                    <td>Compra</td>
                    <td>CDT de {p.duracion}, {p.monto} en {p.proveedor}</td>
                  </tr>
                  {p.cerrado && (
                    <tr>
                      <td>01/07/2024</td>
                      <td>Cierre</td>
                      <td>CDT de {p.duracion}, {p.monto} en {p.proveedor}</td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        ) : (
          <table className="w-full text-left">
            <thead className="border-b border-blue-300">
              <tr>
                <th className="pb-2">Fecha</th>
                <th className="pb-2">Tipo</th>
                <th className="pb-2">Descripción</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-blue-200">
              <tr>
                <td>01/01/2024</td>
                <td>Compra</td>
                <td>CDT de {selectedItem?.duracion}, {selectedItem?.monto} en {selectedItem?.proveedor}</td>
              </tr>
              {selectedItem?.cerrado && (
                <tr>
                  <td>01/07/2024</td>
                  <td>Cierre</td>
                  <td>CDT de {selectedItem?.duracion}, {selectedItem?.monto} en {selectedItem?.proveedor}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Movimientos;
